import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SavingsService } from "./savings.service";
import { jsPDF } from "jspdf";

@Injectable({
  providedIn: 'root'
})
export class PrintreceiptService {

  SavingsData: any;
  constructor(public savingsService: SavingsService, private datePipe: DatePipe) { }

  GetSavingsBySavingsNo(Savings: any): any {

    if (Savings.Id !== 0) { // Parent Loan No number checks
      this.savingsService.selectedSavings.Id = + Savings.Id;
      this.savingsService.FetchSavingsById(this.savingsService.selectedSavings)
        .toPromise()
        .then(res => {
          this.savingsService.selectedSavings = res;
          // this.GenerateReceipt();
          this.GenerateList(res);//
          return Promise.resolve();
        })
        .catch(err => { console.log(err) });
    }
  }

  //--------------------------------------------------
  /// Receipt report
  GenerateReceipt() {

    this.SavingsData = this.savingsService.selectedSavings;
    const totalPagesExp = "{total_pages_count_string}";
    let pdf = new jsPDF('l', 'pt', 'legal');

    // HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.text("Society For Rural Improvements", 380, 40);
    pdf.text("RECEIPT", 435, 90);
    pdf.setLineWidth(1.5);
    pdf.line(5, 105, 995, 105)
    // HEADER END 

    //CONTENT 
    pdf.text("Rec. No   : " + this.SavingsData.Id, 60, 135);
    pdf.text("Date: " + this.datePipe.transform(Date(), 'dd/MM/yyyy'), 660, 135);

    pdf.text("Customer : " + this.SavingsData.CustomerId, 60, 165);
    pdf.text("Application No. : " + this.SavingsData.ApplicationNo, 660, 165);

    pdf.text("Scheme : " + this.SavingsData.SchemeId, 60, 195);
    pdf.text("Installment No. : " + this.SavingsData.Id, 660, 195);

    pdf.text("Amount : " + this.SavingsData.DepositAmount, 60, 225);
    pdf.text("Mode of Remittence : " + this.SavingsData.PaymentTypeId, 660, 225);

    pdf.line(5, 240, 995, 240)

    pdf.text("Cashier : ", 450, 265);
    pdf.text("Manager : ", 650, 265);

    //CONTENT END
    var pageContent = function (result) {
      // HEADER

      // FOOTER
      var str = "Page " + result;
      // Total page number plugin only available in jspdf v1.0+
      if (typeof pdf.putTotalPages === 'function') {
        str = str + " of " + totalPagesExp;
      }
      pdf.setFontSize(10);
      var pageHeight = pdf.internal.pageSize.height || pdf.internal.pageSize.getHeight();
      pdf.text(str, result.settings.margin.left, pageHeight - 10); // showing current page number
    };

    //for adding total number of pages // i.e 10 etc
    if (typeof pdf.putTotalPages === 'function') {
      pdf.putTotalPages(totalPagesExp);
    }

    // pdf.save(title + '.pdf');    
    pdf.setProperties({
      title: "Savings Reciept",
    });

    pdf.output('dataurlnewwindow');
  }

  //--------------------------------------------------
  // Printing the documents as a lists.  
  GenerateList(Savingsdata) {

    var generateData = function (customerdata) {
      var result = [];
      var data = {
        Id: customerdata.Id,
        'Application No': customerdata.ApplicationNo.toString(),
        'Customer': customerdata.CustomerId.toString(),
        'Installment No': customerdata.Id.toString(),
        'Amount': customerdata.DepositAmount.toString(),
        'Scheme': customerdata.SchemeId.toString(),
        'Mode of Remittence': customerdata.PaymentTypeId.toString(),
      };

      for (var i = 0; i < 2; i += 1) {
        data.Id = (i + 1).toString();
        result.push(Object.assign({}, data));
      }
      return result;
    };

    function createHeaders(keys) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 65,
          align: "center",
          padding: 0
        });
      }
      return result;
    }

    var headers = createHeaders([
      "Id",
      "Application No",
      "Customer",
      "Installment No",
      "Amount",
      "Scheme",
      "Mode of Remittence"
    ]);

    let doc = new jsPDF('l', 'pt', 'legal');
    // var doc = new jsPDF({ putOnlyUsedFonts: true, orientation: "landscape" });
    // doc.table(1, 1, generateData(100), headers, { autoSize: true });
    doc.table(1, 1, generateData(Savingsdata), headers, { autoSize: true });
    doc.output('dataurlnewwindow');
  }  
////

}
